import React, { useState, useEffect, useCallback,useMemo } from 'react';
import { getData,addData, updateData,deleteData } from '../../services/seoOpenGraphProtocolServices';
import { Modal,Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import { admin_base_url } from '../../config';
import axios from 'axios';


const Seoopengraphprotocol = () => {
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null,
    page_name:'',
    // context_page:'',
    og_type: '',
    og_url: '',
    og_locale: '',
    og_title: '',
    og_site_name: '',
    og_description: '',
    og_video: '',
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  console.log('errors',errors);
  const [dataList, setDataList] = useState([]);
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [pageNameOptions, setPageNameOptions] = useState([
  //   { value: "", label: "Select Page" }
  // ]); 
   

  // Fetch data from API
  const fetchData = useCallback(async () => {
    setLoading(true);
    try{
    const response = await getData();
    if (response.data.length > 0) {
      setDataList(response.data); // Load first record into the form
    }
  }
   catch (error) {
      console.error('Error fetching data:', error);
    }
    finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


 // Validate form data
  const validateForm = () => {
  const newErrors = {};
  const urlPattern = new RegExp(
  "^(https?:\\/\\/)" + // protocol required
  "((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|" + // domain...
  "localhost|" + // or localhost
  "\\d{1,3}(\\.\\d{1,3}){3})" + // ...or IPv4
  "(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$"
  );

const videoUrlPattern = new RegExp("^(https?:\\/\\/)?(www\\.)?(youtube\\.com\\/watch\\?v=|youtu\\.be\\/)[\\w-]{11}(\\S*)?$");

  if (!formData.og_type) newErrors.og_type = "OG Type is required";
  if (!formData.page_name) newErrors.page_name = "Page name is required";
  // if (!formData.context_page) newErrors.context_page = "Context Page is required";
  if (!formData.og_url){ 
    newErrors.og_url = "OG URL is required";
  }
  else if (!urlPattern.test(formData.og_url)) {
    newErrors.og_url = "Please enter a valid website URL (e.g., https://example.com)";
   }
  if (!formData.og_locale) newErrors.og_locale = "OG Locale is required";
  if (!formData.og_title) newErrors.og_title = "OG Title is required";
  if (!formData.og_site_name) newErrors.og_site_name = "OG Site Name is required";
  if (!formData.og_description) newErrors.og_description = "OG Description is required";
  if (formData.og_description.length < 70 || formData.og_description.length > 200) newErrors.og_description = " og_description should be between 70 and 160 characters";
  if (!formData.og_video){ 
    newErrors.og_video = "OG Video Link is required";
  }
  else if (!videoUrlPattern.test(formData.og_video)) {
    newErrors.og_video = "Please enter a valid YouTube video URL";
  }
  if (!formData.uploadedfile && formData.uploadedfile === null) {
      if (!errors.uploadedfile) newErrors.uploadedfile = " OG Image is required";
  }
  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
}

  // Handle input changes
  const handleChange = async(e) => {
    try{
        const { name, value, files } = e.target;
        const file = files?.[0]
          // Create a copy of the current form data
          let updatedData = { ...formData };
          let updatedErrors = { ...errors };
          if (file) {
              const fileType = file.type.includes("image") ? "img" : "pdf";
              const isValid = await validateFile(file, setErrors,name,fileType);
              if (isValid) {
                updatedData[name] = file;
                updatedErrors[name] = '';
              }
              else{
                return ; // Don't update if invalid
              }
        } 
          else{
          updatedData[name] = value;
            if (name === "page_name") {
              const isDuplicate = dataList.some(
                (item) => item.page_name?.toLowerCase() === value.toLowerCase()
              );

              if (isDuplicate) {
                updatedErrors[name] = "Page name already exists";
              } else {
                updatedErrors[name] = ''; // Clear error if unique
              }
            }
          else if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
        }}
        setFormData(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    try{
    const form = new FormData();
    form.append('id', formData.id);
    form.append('og_type', formData.og_type);
    form.append('page_name', formData.page_name);
    // form.append('context_page', formData.context_page);
    form.append('og_url', formData.og_url);
    form.append('og_locale', formData.og_locale);
    form.append('og_title', formData.og_title);
    form.append('og_site_name', formData.og_site_name);
    form.append('og_description', formData.og_description);
    form.append('og_video', formData.og_video);
    form.append('uploadedfile', formData.uploadedfile);
    if (modalType === 'add') {
      let response = await addData(form);
            if (response.status === 200||201) {
            fetchData();
            setShowModal(false);
              toast.success("Added Successfully!", {
                position: 'top-right',
                autoClose: 3000,
              });
            } 
            else{
                toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
            console.log((response?.message || "Failed to process request."));
            }
          }
    else if (modalType === 'edit') {
        let  response = await updateData(form);
        if (response && response.status === 200) {
          fetchData();  // Re-fetch data after adding/editing
          setShowModal(false);
          toast.success("Updated Successfully!", {position: 'top-right',autoClose: 3000,});
                }
        else{
        toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        console.log((response?.message || "Failed to process request."));
          }
      }
  }
  catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  const handleDelete = async () => {
      try{
      if (selectedData) {
        // Optimistically remove the data from the list
        setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
        // Proceed with the actual delete request
        await deleteData(selectedData.id);
        setShowDeleteConfirmModal(false);
        toast.success("Deleted Successfully!", {position: 'top-right',autoClose: 3000});
      }
    }
    catch (error) {
          console.error('Error deleting data:', error);
        }
    };
  

    const openModal = (type, data = { id: '', page_name: '',
      // context_page:'',
    uploadedfile: null,
    og_type: '',
    og_url: '',
    og_locale: '',
    og_title: '',
    og_site_name: '',
    og_description: '',
    og_video: '',
    }) => {
    setModalType(type);
    setFormData(data);
    setShowModal(true);
  };

  const openDeleteConfirmModal = (data) => {
      setSelectedData(data);
      setShowDeleteConfirmModal(true);
    };
    const handleSearchChange = (e) => {
      setSearchText(e.target.value);
    };
  
    const handlePageChange = (page) => {
      setCurrentPage(page);
    };
  
  // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
      const filtered = dataList.filter(
        (data) =>
          data?.page_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
          data?.og_type?.toLowerCase().includes(searchText?.toLowerCase()) 
      );
      const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      return sortedData;
    }, [dataList, searchText]);

    const columns = [
      {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '10%',
      },
      {
        name: 'Page name',
        selector: (row) => (<span title={row.page_name}>{row.page_name}</span>),
        sortable: true,
        width: '20%',
      },
      {
        name: 'Og Type',
        selector: (row) => (<span title={row.og_type}>{row.og_type}</span>),
        sortable: true,
        width: '20%',
      },
      {
        name: 'Title',
        selector: (row) => (<span title={row.og_title}>{row.og_title}</span>),
        sortable: true,
        width: '20%',
      },

      {
        name: 'Actions',
        cell: (row) => (
          <div>
            <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
            <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
          </div>
        ),
        width: '25%',
      },
    ];

const cms_private_key = localStorage.getItem('cms_private_key');
const cms_sub_domain = localStorage.getItem('cms_sub_domain');
const admin_api_url = `${admin_base_url}api/admin/metaTags`;

// const getPagenames = async () => {
//   try {
//     const res = await axios.get(admin_api_url, {
//       headers: {
//         cms_private_key: cms_private_key, 
//         cms_sub_domain:cms_sub_domain 
//       }
//     });

//     const options = res.data.data.map((item) => ({
//       value: item.page_value,
//       label: item.page_title
//     }));

//     // Add default option on top
//     setPageNameOptions([
//       { value: "", label: "Select Page" },
//       ...options
//     ]);
//   } catch (error) {
//     console.error("Error fetching meta tags:", error);
//   }
// };

// useEffect(() => {
//     getPagenames();
//   }, []);

const pageNameOptions = [
      { value: "", label: "Select Page" },
      { value: "default", label: "Default" },
      // { value: "about-us", label: "About us" },
      // { value: "brochure", label: "Brochure" },
      // { value: "venue", label: "Venue" },
      // { value: "ocm", label: "OCM" },
      // { value: "program-speakers", label: "Program Speakers" },
      // { value: "registration", label: "Registration" },
      // { value: "submit-abstract", label: "Submit Abstract" },
      // { value: "sessions", label: "Sessions" },
      // { value: "home", label: "Home" },
      // { value: "terms-and-conditions", label: "Terms and Conditions" },
      // { value: "contact-us", label: "Contact us" },
      // { value: "webinar-program", label: "Webinar Program" },
      // { value: "scientific-program", label: "Scientific Program" },
      // { value: "about-webinar", label: "About Webinar" },
      // { value: "past-conference", label: "Past Conference" },
      // { value: "pc-report", label: "PC Report" },
      // { value: "pc-proceedings", label: "PC Proceedings" },
      // { value: "pc-attendees", label: "PC Attendees" },
      // { value: "pc-testimonials", label: "PC Testimonials" },
      // { value: "pc-gallery", label: "PC Gallery" },
      // { value: "testimonials", label: "Testimonials" },
      // { value: "supporting-journals", label: "Supporting Journals" },
      // { value: "media-partners", label: "Media Partners" }
    ];

const pageContextOptions = [
      { value: "", label: "Select Context Page" },
      { value: "default", label: "Default" },
      { value: "about-us", label: "About us" },
      { value: "brochure", label: "Brochure" },
      { value: "venue", label: "Venue" },
      { value: "ocm", label: "OCM" },
      { value: "program-speakers", label: "Program Speakers" },
      { value: "registration", label: "Registration" },
      { value: "submit-abstract", label: "Submit Abstract" },
      { value: "sessions", label: "Sessions" },
      { value: "home", label: "Home" },
      { value: "terms-and-conditions", label: "Terms and Conditions" },
      { value: "contact-us", label: "Contact us" },
      { value: "webinar-program", label: "Webinar Program" },
      { value: "scientific-program", label: "Scientific Program" },
      { value: "about-webinar", label: "About Webinar" },
      { value: "past-conference", label: "Past Conference" },
      { value: "pc-report", label: "PC Report" },
      { value: "pc-proceedings", label: "PC Proceedings" },
      { value: "pc-attendees", label: "PC Attendees" },
      { value: "pc-testimonials", label: "PC Testimonials" },
      { value: "pc-gallery", label: "PC Gallery" },
      { value: "testimonials", label: "Testimonials" },
      { value: "supporting-journals", label: "Supporting Journals" },
      { value: "media-partners", label: "Media Partners" }
    ];


const customStyles = (hasError) => ({
  control: (provided, state) => ({
    ...provided,
    borderColor: hasError ? '#f5c2c7' : provided.borderColor, // Light red border
    boxShadow: hasError
      ? '0 0 0 1px rgba(167, 16, 31, 0.91)' // Light red outline glow
      : state.isFocused
        ? '0 0 0 1px #2684FF'
        : provided.boxShadow,
    '&:hover': {
      borderColor: hasError ? '#f5c2c7' : provided.borderColor,
    },
  }),
});

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='mb-3 fs-4'>SEO Config <b>/ Open Graph Protocol</b></p>
              {/* <h2 className='mb-3'>Schema Markup</h2> */}
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
          {/* <h1 className="mb-4">Open Graph Protocol</h1> */}

            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg' backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
          {/* Editable Form (Always Visible) */}
          {/* <div className="card p-3 mb-4"> */}
            {/* <h4 className='mb-3'>Edit Open Graph Protocol</h4> */}
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="mb-3">
                    <label htmlFor="page_name" className="form-label">Page Name <small className='text-danger'> * </small></label>
                    <Select
                      id="page_name"
                      name="page_name"
                      value={pageNameOptions.find(opt => opt.value === formData.page_name)}
                      onChange={(selectedOption) =>
                        handleChange({
                          target: {
                            name: 'page_name',
                            value: selectedOption?.value || ''
                          }
                        })
                      }
                      options={pageNameOptions}
                      // className={errors.page_name ? 'is-invalid' : ''}
                      styles={customStyles(!!errors.page_name)}
                      placeholder="Select Page"
                    />
                    {errors.page_name && (
                      <div className="invalid-feedback d-block">
                        {errors.page_name}
                      </div>
                    )}
                  </div>

                  {/* <div className="mb-3">
                    <label htmlFor="context_page" className="form-label">Context Page<small className='text-danger'> * </small></label>
                    <Select
                      id="context_page"
                      name="context_page"
                      value={pageNameOptions.find(opt => opt.value === formData.context_page)}
                      onChange={(selectedOption) =>
                        handleChange({
                          target: {
                            name: 'context_page',
                            value: selectedOption?.value || ''
                          }
                        })
                      }
                      options={pageContextOptions}
                      // className={errors.context_page ? 'is-invalid' : ''}
                      styles={customStyles(!!errors.context_page)}
                      placeholder="Select Context Page"
                    />
                    {errors.context_page && (
                      <div className="invalid-feedback d-block">
                        {errors.context_page}
                      </div>
                    )}
                  </div> */}
              <Form.Group className="col-md-4 mb-3">
                <Form.Label className='form-label-custom'>OG Type <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="text"
                  name="og_type"
                  value={formData.og_type}
                  onChange={handleChange}
                  isInvalid = {!!errors.og_type}
                />
                <Form.Control.Feedback type="invalid">{errors.og_type}</Form.Control.Feedback>               

              </Form.Group>

              <Form.Group className="col-md-4 mb-3">
                <Form.Label className='form-label-custom'>OG URL<small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="url"
                  name="og_url"
                  value={formData.og_url}
                  onChange={handleChange}
                  isInvalid = {!!errors.og_url}
                />
                <Form.Control.Feedback type="invalid">{errors.og_url}</Form.Control.Feedback>               

              </Form.Group>
              <Form.Group className="col-md-4 mb-3">
                <Form.Label className='form-label-custom'>OG Locale <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="text"
                  name="og_locale"
                  value={formData.og_locale}
                  onChange={handleChange}
                  isInvalid = {!!errors.og_locale}
                />
                <Form.Control.Feedback type="invalid">{errors.og_locale}</Form.Control.Feedback>               

              </Form.Group>
              <Form.Group className="col-md-8 mb-3">
                <Form.Label className='form-label-custom'>OG Title <small className='text-danger'> * </small> Note: <small className='text-primary'>Emptying the OG title will disable OG tags on the website</small></Form.Label>
                <Form.Control
                  type="text"
                  name="og_title"
                  value={formData.og_title}
                  onChange={handleChange}
                  isInvalid = {!!errors.og_title}
                />
                <Form.Control.Feedback type="invalid">{errors.og_title}</Form.Control.Feedback>               

              </Form.Group>
              <Form.Group className="col-md-4 mb-3">
                <Form.Label className='form-label-custom'>OG Site Name <small className='text-danger'> * </small></Form.Label>
                <Form.Control
                  type="text"
                  name="og_site_name"
                  value={formData.og_site_name}
                  onChange={handleChange}
                  isInvalid = {!!errors.og_site_name}
                />
                <Form.Control.Feedback type="invalid">{errors.og_site_name}</Form.Control.Feedback>               
              </Form.Group>
            
              <Form.Group className="col-md-12 mb-3">
                <Form.Label className='form-label-custom'>OG Description <small className='text-danger'> * </small> <small className='text-primary'> Char limit: 70-200 | Current char count: {formData.og_description.length}</small></Form.Label>
                <Form.Control
                    as="textarea"
                    rows={8} // You can adjust the number of visible rows
                    name="og_description"
                    value={formData.og_description}
                    onChange={handleChange}
                    isInvalid = {!!errors.og_description}
                />
                <Form.Control.Feedback type="invalid">{errors.og_description}</Form.Control.Feedback>               
              </Form.Group>

              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>OG Image <small className='text-danger'> * </small> <small className='text-primary'>(Dim: 1200X630px | Max-Size: 1MB)</small></Form.Label>
                <Form.Control type="file" name="uploadedfile" onChange={handleChange}  isInvalid = {!!errors.uploadedfile} accept="image/*"/>
                <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>               

                {formData.uploadedfile && typeof formData.uploadedfile === 'string' && (
                  <p>
                    <a href={formData.uploadedfile} target="_blank" rel="noopener noreferrer">
                      View Current File
                    </a>
                  </p>
                )}
              </Form.Group>
              
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>OG Video Link <small className='text-danger'> * </small></Form.Label>
                <Form.Control
                  type="text"
                  name="og_video"
                  value={formData.og_video}
                  onChange={handleChange}
                  isInvalid = {!!errors.og_video}
                />
                <Form.Control.Feedback type="invalid">{errors.og_video}</Form.Control.Feedback>               

              </Form.Group>
              <Form.Group className="col-md-6 mb-3">
              {formData.og_img && <Form.Label className='form-label-custom'>OG Image Preview &nbsp;</Form.Label>}
              {formData.og_img && (
                <div style={{height:'150px',width: '200px'}}>
                  <img  className='rounded' src={formData.og_img} alt="og preview" 
                   width='100%' height='100%'  
                    style={{ objectFit: 'cover' }}
                    crossOrigin="anonymous"
                  />
                </div>
              )}
              </Form.Group>
              </div>
              {/* <Button variant="success" type="submit">Save</Button> */}
            </Form>
            </Modal.Body>
        <Modal.Footer className='border-0'>
          <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
          <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete this row?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDelete}>
              Yes, Delete
            </Button>
          </Modal.Footer>
        </Modal>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Seoopengraphprotocol;
